/** Server visit itinerary — booked + proposed + queued with consent states. */

export type ItineraryStopStatus = 'queued' | 'proposed' | 'booked';
export type ItineraryConsent = 'none' | 'awaiting' | 'confirmed';

export interface VisitItineraryStop {
  project_id: string;
  project_name: string;
  iso?: string;
  label?: string;
  status: ItineraryStopStatus;
  consent: ItineraryConsent;
  drive_from_prev_min?: number;
  drive_source?: 'distance_matrix' | 'haversine' | 'none';
}

export interface VisitItineraryPayload {
  day_label?: string;
  origin_label?: string;
  route_ordered?: boolean;
  stops: VisitItineraryStop[];
}

export function itineraryRouteProjectIds(itinerary: VisitItineraryPayload): string[] {
  return itinerary.stops.map((s) => s.project_id);
}
